/** @format */
import React from 'react';
import { Button, Card, CardActions, CardContent, Grid, Typography } from '@mui/material';
import { useStyles } from './style';
const UpgradeCondition = ({ txtUpgrade, submitHint }) => {
  const classes = useStyles();

  return (
    <Grid item xs={12}>
      <Card className={classes.cardAlert}>
        <CardContent>
          <Typography className={classes.cardTitle} color="textSecondary" gutterBottom>
            شرایط ارتقا کسب‌وکار
          </Typography>
          <Typography className={classes.cardBody} color="textSecondary">
            {txtUpgrade}
          </Typography>
        </CardContent>
        <CardActions>
          <Button size="small" color="primary" onClick={() => submitHint(true)}>
            متوجه شدم
          </Button>
        </CardActions>
      </Card>
    </Grid>
  );
};

export default UpgradeCondition;
